import { UseUserInvestmentDocumentsResult } from '@dealstack/frontend/investor/pages/Valuations/hooks/types';
import { shareholderInvestorControllerGetInvestorDocumentsOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { useQuery } from '@tanstack/react-query';

export const useUserInvestmentDocuments = ({
	enabled,
	investorId,
}: {
	enabled: boolean;
	investorId?: string;
}): UseUserInvestmentDocumentsResult => {
	const query = useQuery({
		// Generated query options: the queryFn unwraps the response, throws on
		// error, and forwards the abort signal.
		...shareholderInvestorControllerGetInvestorDocumentsOptions({ query: { investorId } }),
		enabled,
	});

	return {
		documents: query.data,
		isLoading: query.isLoading,
		isError: query.isError,
	};
};
